var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoorLeave = function SvgDoorLeave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 38 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.45 32.587c0-.874-.708-1.582-1.582-1.582H7.961V8.865h7.907a1.581 1.581 0 0 0 0-3.163H7.961a3.163 3.163 0 0 0-3.163 3.163v22.14a3.163 3.163 0 0 0 3.163 3.163h7.907c.874 0 1.582-.708 1.582-1.581",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.393 21.043a1.58 1.58 0 0 0 .452-1.103v-.01a1.58 1.58 0 0 0-.463-1.113l-6.325-6.326a1.581 1.581 0 1 0-2.237 2.237l3.626 3.626h-15.16a1.581 1.581 0 1 0 0 3.163h15.16l-3.626 3.626a1.581 1.581 0 1 0 2.236 2.236l6.325-6.324z"
  })));
};
export default SvgDoorLeave;